import { notifyToast } from "../components/motion/toast-notifications";

export const createNotification = (type, message, timeout, subText) => {
  const status = ["info", "success", "warning", "error"].includes(type)
    ? type
    : "neutral";

  notifyToast({
    status,
    title: message || "Notification",
    description: subText || undefined,
    duration: typeof timeout === "number" ? timeout : 3000,
  });
};
